export const MIC_ENABLED_STORAGE_KEY = 'beeylive-mic-enabled';
export const PREFERRED_AUDIO_SOURCE_DEVICE_ID_KEY = 'beeylive-preferred-audio-source-device-id';
export const readMicEnabled = () => localStorage.getItem(MIC_ENABLED_STORAGE_KEY) === 'true';
export const writeMicEnabled = (enabled) => {
    if (enabled) {
        localStorage.setItem(MIC_ENABLED_STORAGE_KEY, 'true');
    }
    else {
        localStorage.removeItem(MIC_ENABLED_STORAGE_KEY);
    }
};
export const readPreferredAudioSourceDeviceId = () => localStorage.getItem(PREFERRED_AUDIO_SOURCE_DEVICE_ID_KEY);
export const writePreferredAudioSourceDeviceId = (deviceId) => {
    if (deviceId !== null) {
        localStorage.setItem(PREFERRED_AUDIO_SOURCE_DEVICE_ID_KEY, deviceId);
    }
    else {
        localStorage.removeItem(PREFERRED_AUDIO_SOURCE_DEVICE_ID_KEY);
    }
};
export const persistOwnConnectionMicFromSnapshot = (snapshot, connectionId) => {
    const ownConnection = snapshot.connections.find((connection) => connection.id === connectionId);
    const deviceId = ownConnection?.selectedAudioSourceDeviceId;
    if (deviceId !== null && deviceId !== undefined && deviceId !== '') {
        writePreferredAudioSourceDeviceId(deviceId);
    }
};
